import { FC, PropsWithChildren, ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from './ui/tooltip';
import { cn } from '../utils/cn';
import { TooltipContentProps } from '@radix-ui/react-tooltip';
export const OptionalTooltip: FC<PropsWithChildren<{
  className?: string;
  tooltipContent: ReactNode;
  align?: TooltipContentProps['align'];
  side?: TooltipContentProps['side'];
}>> = ({
  children,
  tooltipContent,
  className,
  align = 'end',
  side
}) => {
  return tooltipContent ? <Tooltip data-sentry-element="Tooltip" data-sentry-component="OptionalTooltip" data-sentry-source-file="optional-tooltip.tsx">
      <TooltipTrigger className={cn('flex-1', className)} data-sentry-element="TooltipTrigger" data-sentry-source-file="optional-tooltip.tsx">{children}</TooltipTrigger>
      <TooltipContent className="p-2" align={align} side={side} data-sentry-element="TooltipContent" data-sentry-source-file="optional-tooltip.tsx">
        {tooltipContent}
      </TooltipContent>
    </Tooltip> : children;
};